import React from 'react';
import styled from 'styled-components';
import {theme} from "@/components/features/theme/theme";
import Link from "next/link";

const Social = ({iconColor, facebook, twitter, instra, linkedin, youtube, pinterest, bg, hoverbg, iconhover}) => {


  return (

    <StyledSocial iconhover={iconhover} className={'social-item-wrapper'}>
      <ul className={'social'}>
        {
            facebook &&
            <li><Link href={facebook} prefetch={true}
                      target={'_blank'} rel="noreferrer">
                <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect width="30" height="30" rx="4" fill="white" />
                    <path d="M12.4534 16.1602C12.3858 16.1602 10.8989 16.1602 10.2231 16.1602C9.86264 16.1602 9.75 16.025 9.75 15.6871C9.75 14.786 9.75 13.8623 9.75 12.9612C9.75 12.6008 9.88517 12.4881 10.2231 12.4881H12.4534C12.4534 12.4205 12.4534 11.1139 12.4534 10.5056C12.4534 9.60451 12.6111 8.74844 13.0616 7.95995C13.5347 7.14894 14.2106 6.60826 15.0666 6.29287C15.6298 6.09011 16.1931 6 16.8013 6H19.0091C19.3245 6 19.4596 6.13517 19.4596 6.45056V9.01877C19.4596 9.33417 19.3245 9.46934 19.0091 9.46934C18.4008 9.46934 17.7926 9.46934 17.1843 9.49186C16.576 9.49186 16.2606 9.78473 16.2606 10.4155C16.2381 11.0914 16.2606 11.7447 16.2606 12.4431H18.8739C19.2344 12.4431 19.3695 12.5782 19.3695 12.9387V15.6646C19.3695 16.025 19.2569 16.1377 18.8739 16.1377C18.0629 16.1377 16.3282 16.1377 16.2606 16.1377V23.4819C16.2606 23.8648 16.148 24 15.7425 24C14.7963 24 13.8727 24 12.9265 24C12.5885 24 12.4534 23.8648 12.4534 23.5269C12.4534 21.1615 12.4534 16.2278 12.4534 16.1602Z"
                          fill="#152637" />
                </svg>

            </Link>
            </li>

        }

          {
              twitter &&
              <li><Link prefetch={true} href={twitter}
                        target={'_blank'} rel="noreferrer">

                  <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <rect width="30" height="30" rx="4" fill="white" />
                      <path d="M16.6769 13.6218L23.2337 6H21.68L15.9867 12.6179L11.4395 6H6.19482L13.0711 16.0074L6.19482 24H7.74867L13.7609 17.0113L18.5631 24H23.8078L16.6765 13.6218H16.6769ZM14.5487 16.0956L13.852 15.0991L8.30854 7.16971H10.6952L15.1688 13.5689L15.8655 14.5655L21.6807 22.8835H19.2941L14.5487 16.096V16.0956Z" fill="#152637" />
                  </svg>

              </Link>
              </li>

          }

          {
              instra &&
              <li><Link prefetch={true} href={instra}
                        target={'_blank'} rel="noreferrer">
                  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <rect width="20" height="20" rx="4" fill="#BFA68B" />
                      <path d="M15.0001 15.0001V11.3376C15.0001 9.5376 14.6126 8.1626 12.5126 8.1626C11.5001 8.1626 10.8251 8.7126 10.5501 9.2376H10.5251V8.3251H8.5376V15.0001H10.6126V11.6876C10.6126 10.8126 10.7751 9.9751 11.8501 9.9751C12.9126 9.9751 12.9251 10.9626 12.9251 11.7376V14.9876H15.0001V15.0001Z" fill="white" />
                      <path d="M5.1626 8.3252H7.2376V15.0002H5.1626V8.3252Z" fill="white" />
                      <path d="M6.2 5C5.5375 5 5 5.5375 5 6.2C5 6.8625 5.5375 7.4125 6.2 7.4125C6.8625 7.4125 7.4 6.8625 7.4 6.2C7.4 5.5375 6.8625 5 6.2 5Z" fill="white" />
                  </svg>


              </Link>
              </li>
          }

          {

              youtube &&
              <li><Link prefetch={true} href={youtube}
                        target={'_blank'} rel="noreferrer">
                  <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <rect width="30" height="30" rx="4" fill="white" />
                      <path d="M23.6291 10.6713C23.4217 9.90014 22.8137 9.29226 22.0427 9.08462C20.6341 8.69922 14.9998 8.69922 14.9998 8.69922C14.9998 8.69922 9.36567 8.69922 7.95711 9.07001C7.20092 9.27743 6.5781 9.90025 6.37068 10.6713C6 12.0797 6 15.0007 6 15.0007C6 15.0007 6 17.9363 6.37068 19.33C6.57832 20.1011 7.18609 20.7089 7.95722 20.9166C9.3805 21.3021 15 21.3021 15 21.3021C15 21.3021 20.6341 21.3021 22.0427 20.9313C22.8138 20.7238 23.4217 20.1159 23.6294 19.3449C23.9999 17.9363 23.9999 15.0155 23.9999 15.0155C23.9999 15.0155 24.0148 12.0797 23.6291 10.6713ZM13.2059 17.6991V12.3022L17.8912 15.0007L13.2059 17.6991Z" fill="#152637" />
                  </svg>

              </Link></li>

          }

          {
              linkedin &&
              <li>
                  <Link href={linkedin} prefetch={true} target={'_blank'} rel="noreferrer">
                      <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <rect width="30" height="30" rx="4" fill="white" />
                          <path d="M22.4999 22.4994V17.0057C22.4999 14.3057 21.9187 12.2432 18.7687 12.2432C17.2499 12.2432 16.2374 13.0682 15.8249 13.8557H15.7874V12.4869H12.8062V22.4994H15.9187V17.5307C15.9187 16.2182 16.1624 14.9619 17.7749 14.9619C19.3687 14.9619 19.3874 16.4432 19.3874 17.6057V22.4807H22.4999V22.4994Z" fill="#152637" />
                          <path d="M7.74365 12.4883H10.8562V22.5008H7.74365V12.4883Z" fill="#152637" />
                          <path d="M9.3 7.5C8.30625 7.5 7.5 8.30625 7.5 9.3C7.5 10.2938 8.30625 11.1187 9.3 11.1187C10.2938 11.1187 11.1 10.2938 11.1 9.3C11.1 8.30625 10.2938 7.5 9.3 7.5Z" fill="#152637" />
                      </svg>


                  </Link>
              </li>
          }

          {
              pinterest &&
              <li>
                  <Link prefetch={true} href={pinterest} target={'_blank'} rel="noreferrer">

                      <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30">
                          <g id="Group_23863" data-name="Group 23863" transform="translate(17861 4413)">
                              <circle id="Ellipse_99" data-name="Ellipse 99" cx="15" cy="15" r="15" transform="translate(-17861 -4413)" fill={bg ? bg : theme.colors.hover} />
                              <circle id="Ellipse_98" className={'hover_circle'} data-name="Ellipse 99" cx="15" cy="15" r="0" transform="translate(-17861 -4413)" fill={hoverbg ? hoverbg : theme.colors.hover}/>
                              <g id="Group_23857" data-name="Group 23857" transform="translate(-17884.176 -4406.076)">
                                  <path id="Path_9210" data-name="Path 9210" d="M44.92,4.239a3.873,3.873,0,0,1-2.34-.782A3.874,3.874,0,0,1,41.033.39h-2.51V7.248l0,3.756a2.275,2.275,0,1,1-1.56-2.156V6.3a4.939,4.939,0,0,0-.724-.054A4.812,4.812,0,0,0,32.62,7.864a4.716,4.716,0,0,0,.213,6.5,4.9,4.9,0,0,0,.453.4,4.813,4.813,0,0,0,2.95,1,4.939,4.939,0,0,0,.724-.053,4.8,4.8,0,0,0,2.68-1.34,4.7,4.7,0,0,0,1.41-3.344l-.013-5.609a6.359,6.359,0,0,0,3.891,1.322v-2.5H44.92Z" fill={iconColor ? iconColor : theme.colors.hover}/>
                    </g>
                  </g>
                </svg>

              </Link>
            </li>
        }


      </ul>
    </StyledSocial>

  );
};


const StyledSocial = styled.div`
    margin-bottom: 0;

    .social {
        display: flex;
        flex-direction: row;
        gap: 15px;

        li {
            list-style: none !important;
            cursor: pointer;

            &:after {
                display: none !important;
            }

            &:before {
                display: none !important;
            }

            a {
                &:after {
                    display: none !important;
                }

                &:before {
                    display: none !important;
                }
            }
        }

        svg {
            overflow: hidden;
            border-radius: 4px;
            height: 20px;
            width: 20px;

            .hover_circle, path, rect {
                transition: ${theme.transition};
            }
        }

        li {
            margin-left: 0;
            margin-bottom: 0 !important;
            &:first-child {
                margin-left: 0;
            }

            a {
                &:hover {
                    svg {
                        .hover_circle {
                            r: 15px;
                        }

                        rect {
                            fill: ${theme.colors.white};
                        }

                        path {
                            fill: ${(props) => (props.iconhover ? props.iconhover : theme.colors.hover)} !important;
                        }


                    }
                }
            }
        }
    }

    @media (max-width: 992px) and (min-width: 767px) {
        .social {
            flex-wrap: wrap;
            align-items: flex-end;
            justify-content: flex-end;
            gap: 20px;

            li {
                margin-left: 0;
            }
        }
    }
`;

export default React.memo(Social);














